import humps from 'humps'

import i18nInstance from '../i18n/i18nInstance'

const SUCCESS = 'success'
const NEEDS_CONFIRM = 'needs_confirm'

const t = i18nInstance.getFixedT(null, '@mc/authentication')

const serialize = (obj) =>
  Object.keys(obj)
    .map((key) => `${key}=${encodeURIComponent(obj[key])}`)
    .join('&')

export const params = (data, method = 'POST') => ({
  method,
  body: serialize(data),
})

export const isSuccessful = (res) => res?.status === SUCCESS
export const needsConfirmation = (res) => res?.status === NEEDS_CONFIRM
export const getError = () => new Error(t('error'))

const handleErrors = (response) =>
  new Promise((resolve, reject) => {
    if (!response) {
      reject(new Error('No response returned from fetch'))
      return
    }

    if (response.ok) {
      resolve(response)
      return
    }

    response
      .json()
      .then((json) => {
        const error = json || { message: response.statusText }
        error.statusCode = response.status
        reject(error)
      })
      .catch(() => {
        reject(new Error('Response not JSON'))
      })
  })

const getResponseBody = (response) => {
  const bodyIsEmpty = response.status === 204
  if (bodyIsEmpty) {
    return Promise.resolve()
  }
  return response.json()
}

const request = (url, { headers, ...options } = {}) =>
  new Promise((resolve, reject) => {
    fetch('/api/v2/csrf-token')
      .then(getResponseBody)
      .then(({ token }) => {
        fetch(url, {
          ...options,
          credentials: 'include',
          headers: {
            'Content-Type': 'application/x-www-form-urlencoded',
            'X-CSRF-Token': token,
            ...headers,
          },
        })
          .then(handleErrors)
          .then(getResponseBody)
          .then((response) => resolve(humps.camelizeKeys(response)))
          .catch((error) => reject(humps.camelizeKeys(error)))
      })
  })

export default request
